import { OnInit, TemplateRef } from '@angular/core';
import { isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { BpgEventsService } from '../../bpg-events.service';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { BpgCommonService } from '../../../bpg-common/services/bpg-common.service';
import { Router } from '@angular/router';
import { DataService } from "../../../bpg-common/services/data.services";
import { DatePipe } from '@angular/common';
import { ConstantValues } from '../../../bpg-common/models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
var RED_CELL = 'red-cell';
var colors = {
    backgroundColor: {
        primary: '	#b62027',
    }
};
var EventsCalendarComponent = /** @class */ (function () {
    /**
    * @class EventsListViewComponent
    * @constructor
    */
    function EventsCalendarComponent(bpgEventsService, bpgCommonService, router, data, datePipe, spinner, environment) {
        this.bpgEventsService = bpgEventsService;
        this.bpgCommonService = bpgCommonService;
        this.router = router;
        this.data = data;
        this.datePipe = datePipe;
        this.spinner = spinner;
        this.environment = environment;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.selectedSiteId = Number(localStorage.getItem('userSiteId'));
        this.eventList = [];
        this.eventDetail = [];
        this.deviceInfo = null;
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
        this.selectAllConstant = "Select All";
        this.view = CalendarView.Month;
        this.CalendarView = CalendarView;
        this.viewDate = new Date();
        this.showNextDate = new Date();
        this.showPrevDate = new Date();
        this.previousMonth = new Date();
        this.nextMonth = new Date();
        this.cssClass = RED_CELL;
        this.refresh = new Subject();
        this.events = [];
        this.activeDayIsOpen = false;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
        this.isExpanded = false;
    }
    EventsCalendarComponent.prototype.dayClicked = function (_a) {
        var date = _a.date, events = _a.events;
        if (isSameMonth(date, this.viewDate)) {
            this.viewDate = date;
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
                events.length === 0) {
                this.activeDayIsOpen = false;
            }
            else {
                this.activeDayIsOpen = true;
            }
        }
        this.date = this.viewDate;
    };
    EventsCalendarComponent.prototype.handleEvent = function (_action, event) {
        this.getEventCompleteDetails(event.id);
        event.cssClass = 'red-cell';
    };
    EventsCalendarComponent.prototype.getEventCompleteDetails = function (id) {
        for (var _i = 0, _a = this.eventList; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.eventId === id) {
                this.eventDetail = e;
            }
        }
        this.viewEventDetails(this.eventDetail);
    };
    EventsCalendarComponent.prototype.setPreviousMonth = function () {
        this.date = this.viewDate;
        this.prevYear = this.previousMonth.getFullYear();
        this.nxtYear = this.previousMonth.getFullYear() + 1;
        this.showPrevDate = this.previousMonth;
        this.showNextDate = this.nextMonth;
        this.prevMonth = this.prevMonth - 1;
        this.nxtMonth = this.nxtMonth - 1;
        //previous goes nagative
        if (this.prevMonth < 0) {
            this.prevMonth = 11;
            this.prevYear = this.prevYear - 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //Next goes nagative
        if (this.nxtMonth < 0) {
            this.nxtMonth = 11;
            this.nxtYear = this.nxtYear - 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        //previous goes beyond
        if (this.prevMonth > 11) {
            this.prevMonth = 0;
            this.prevYear = this.nxtYear + 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //next goes beyond
        if (this.nxtMonth > 11) {
            this.nxtMonth = 0;
            this.nxtYear = this.nxtYear + 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
        this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
        // updates from date and to date
        this.currentMonth.setMonth(this.currentMonth.getMonth() - 1);
        this.updateDates(this.date);
        // load calendar data accordingly
        this.searchEvents();
    };
    EventsCalendarComponent.prototype.setNextMonth = function () {
        this.date = this.viewDate;
        this.prevYear = this.previousMonth.getFullYear();
        this.nxtYear = this.previousMonth.getFullYear();
        this.showPrevDate = this.previousMonth;
        this.showNextDate = this.nextMonth;
        this.prevMonth = this.prevMonth + 1;
        this.nxtMonth = this.nxtMonth + 1;
        //previous goes nagative
        if (this.prevMonth < 0) {
            this.prevMonth = 11;
            this.prevYear = this.prevYear - 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //Next goes nagative
        if (this.nxtMonth < 0) {
            this.nxtMonth = 11;
            this.nxtYear = this.nxtYear - 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        //previous goes beyond
        if (this.prevMonth > 11) {
            this.prevMonth = 0;
            this.prevYear = this.nxtYear + 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //next goes beyond
        if (this.nxtMonth > 11) {
            this.nxtMonth = 0;
            this.nxtYear = this.nxtYear + 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
        this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
        // update from date and to date
        this.currentMonth.setMonth(this.currentMonth.getMonth() + 1);
        this.updateDates(this.date);
        // load calendar data accordingly
        this.searchEvents();
    };
    EventsCalendarComponent.prototype.setCalendarMonth = function () {
        this.prevYear = this.previousMonth.getFullYear();
        this.nxtYear = this.previousMonth.getFullYear();
        this.showPrevDate = this.viewDate;
        this.showNextDate = this.viewDate;
        this.nxtMonth = this.showNextDate.getMonth() + 1;
        this.prevMonth = this.showPrevDate.getMonth() - 1;
        //previous goes nagative
        if (this.prevMonth < 0) {
            this.prevMonth = 11;
            this.prevYear = this.prevYear - 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //Next goes nagative
        if (this.nxtMonth < 0) {
            this.nxtMonth = 11;
            this.nxtYear = this.nxtYear - 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        //previous goes beyond
        if (this.prevMonth > 11) {
            this.prevMonth = 0;
            this.prevYear = this.nxtYear + 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //next goes beyond
        if (this.nxtMonth > 11) {
            this.nxtMonth = 0;
            this.nxtYear = this.nxtYear + 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
        this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
    };
    EventsCalendarComponent.prototype.setCalendarMonthForDate = function (date) {
        this.prevYear = date.getFullYear();
        this.nxtYear = date.getFullYear();
        this.nxtMonth = date.getMonth() + 1;
        this.prevMonth = date.getMonth() - 1;
        if (this.prevMonth < 0) {
            this.prevMonth = 11;
            this.prevYear = this.prevYear - 1;
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        else {
            this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
        }
        //next goes beyond
        if (this.nxtMonth > 11) {
            this.nxtMonth = 0;
            this.nxtYear = this.nxtYear + 1;
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        else {
            this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
        }
        this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
        this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
        // update from date and to date
        this.updateDates(date);
    };
    EventsCalendarComponent.prototype.eventsPresent = function (data) {
        this.adminId = localStorage.getItem('adminId');
        if (localStorage.getItem('isbpgAdmin') === 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        if (localStorage.getItem('isNaacAdmin') === 'true') {
            this.isNaacAdmin = true;
        }
        this.events = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var data1 = data_1[_i];
            var date = data1.eventCreateDate;
            date = date.substring(0, 10).split('-');
            var virtualflag = void 0;
            if (data1.virtualFlag === true) {
                virtualflag = " | [VIRTUAL]";
            }
            else {
                virtualflag = " ";
            }
            if (data1.eventLevelFlag === false && (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin)) {
                virtualflag = " | [NAAC]";
            }
            date = date[1] + "/" + date[2] + "/" + date[0];
            this.events.push({
                id: data1.eventId,
                start: new Date(date),
                end: new Date(date),
                title: data1.siteName.split("(")[0] + " - " + data1.bpgName.split("(")[0] + "  |  " + data1.eventName + " " + virtualflag,
                color: colors.backgroundColor,
                cssClass: 'red',
                allDay: true,
            });
        }
    };
    EventsCalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentMonth = new Date();
        this.updateDates();
        if (this.isIEOrEdge) {
            this.deviceInfo = 'IE';
        }
        else {
            this.deviceInfo = 'Chrome';
        }
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        this.spinner.show();
        sessionStorage.removeItem("MembershipData");
        this.data.siteIdAndPath.subscribe(function (siteIdAndPath) { return _this.siteAndPath = siteIdAndPath; });
        if (this.siteAndPath.path === 'naacHome') {
            this.selectedSiteId = this.siteAndPath.siteId;
            this.selectedErgId = this.siteAndPath.naacAffinityId;
        }
        if (this.siteAndPath.path === 'eventViewDetails') {
            this.date = new Date(this.siteAndPath.eventCreateDate + 'T00:00:00');
            this.selectedSiteId = (this.siteAndPath.siteId) ? this.siteAndPath.siteId : 0;
            this.selectedErgId = (this.siteAndPath.bpgId) ? this.siteAndPath.bpgId : null;
            this.selectedBpg = this.siteAndPath.bpgName;
            this.selectedSite = this.siteAndPath.siteName;
            if (this.selectedErgId === null || this.selectedBpg === this.selectAllConstant) {
                this.selectedBpg = this.selectAllConstant;
            }
            else {
                this.selectedBpg = '--Select ERG--';
            }
            if (this.selectedSiteId === 0 || this.selectedSite === this.selectAllConstant) {
                this.selectedSite = this.selectAllConstant;
            }
            else {
                this.selectedSite = '--Select Site--';
            }
            this.searchKey = (this.siteAndPath.searchKey) ? this.siteAndPath.searchKey : '';
            this.onDateChange(this.date);
            this.siteAndPath.path = null;
        }
        else if (this.eventDate != null && this.eventDate !== 'null') {
            this.date = new Date(this.eventDate);
            this.viewDate = this.date;
            this.setCalendarMonthForDate(this.date);
        }
        else if (this.siteAndPath !== 'default message') {
            if (this.siteAndPath.eventCreateDate != null) {
                if (this.deviceInfo === 'IE') {
                    this.date = this.datePipe.transform(this.siteAndPath.eventCreateDate, 'yyyy-MM-dd');
                    this.date = new Date(this.date);
                }
                else {
                    this.date = new Date(this.siteAndPath.eventCreateDate);
                }
                this.siteAndPath.eventCreateDate = null;
            }
            else {
                this.date = new Date();
            }
            this.onDateChange(this.date);
        }
        else {
            this.date = new Date();
        }
        this.loginData1 = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
        this.getSiteDetailsOnLoad();
        // setTimeout(function () {
        //   this.spinner.hide();
        // }.bind(this), 500);
    };
    EventsCalendarComponent.prototype.getSiteDetailsOnLoad = function () {
        var _this = this;
        this.siteData = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe(function (data) {
            _this.siteList = data;
            //filter default site from sitelist
            _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteList.unshift({ siteId: 0, siteName: _this.selectAllConstant });
            if (_this.siteList != null) {
                // for defualt site change siteId
                if (_this.selectedSiteId !== 22) {
                    var selectedSite = _this.siteList.find(function (s) { return s.siteId === _this.selectedSiteId; });
                    if (selectedSite) {
                        _this.selectedSite = selectedSite.siteName;
                    }
                    else {
                        // Handle case where selectedSiteId is not found
                        _this.selectedSiteId = _this.siteList[1].siteId;
                        _this.selectedSite = _this.siteList[1].siteName;
                    }
                }
                else {
                    _this.selectedSiteId = _this.siteList[1].siteId;
                    _this.selectedSite = _this.siteList[1].siteName;
                }
            }
            _this.getBPGDetailsOnLoad();
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    EventsCalendarComponent.prototype.getBPGDetailsOnLoad = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteId
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgList = data;
            _this.bpgList.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
            if (_this.bpgList != null) {
                var selectedBpg = _this.bpgList.find(function (b1) { return b1.bpgId === _this.selectedErgId; });
                if (selectedBpg) {
                    _this.selectedBpg = selectedBpg.bpgName;
                }
            }
            _this.afterAllDetailsLoad();
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    EventsCalendarComponent.prototype.afterAllDetailsLoad = function () {
        var _this = this;
        this.data.eventDate.subscribe(function (eventDate) { return _this.eventDate = eventDate; });
        this.setCalendarMonth();
        this.loginData1 = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
        var fromDate = this.datePipe.transform(this.fromDate, ConstantValues.dateFormats.dateFormat);
        var toDate = this.datePipe.transform(this.toDate, ConstantValues.dateFormats.dateFormat);
        this.landingData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                    "fromDate": fromDate,
                    "toDate": toDate
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "",
                "size": 1000,
                "sortDirection": "ASC",
                "sortProperty": null,
                "uid": ""
            };
        localStorage.setItem('eventsCalendarItems', JSON.stringify(this.landingData));
        this.previousButton = sessionStorage.getItem(this.buttonType);
        this.sarchedEventCalendarItems = this.landingData;
        if (JSON.parse(localStorage.getItem('searchedEventsCaledarItems')) !== undefined) {
            if (this.previousButton === 'BACK') {
                this.landingData = JSON.parse(localStorage.getItem('searchedEventsCaledarItems'));
                localStorage.removeItem('searchedEventsCaledarItems');
                sessionStorage.removeItem(this.buttonType);
            }
        }
        else {
            this.landingData = JSON.parse(localStorage.getItem('eventsCalendarItems'));
        }
        sessionStorage.removeItem(this.buttonType);
        this.getAllEvents();
    };
    EventsCalendarComponent.prototype.updateDates = function (selectedDate) {
        var year = selectedDate ? selectedDate.getFullYear() : this.currentMonth.getFullYear();
        var month = selectedDate ? selectedDate.getMonth() : this.currentMonth.getMonth();
        // Set from date to the first day of the current month
        this.fromDate = new Date(year, month, 1);
        // Set to date to the last day of the current month
        this.toDate = new Date(year, month + 1, 0);
    };
    /** For getting all events
    * @class EventsListViewComponent
    * @method getAllEvents
    * @returns Promise
    */
    EventsCalendarComponent.prototype.getAllEvents = function () {
        var _this = this;
        this.spinner.show();
        this.landingData.filter.userId = this.loginData.userId;
        this.bpgEventsService.getAllEvents(this.landingData).subscribe(function (data) {
            if (data != null) {
                _this.eventList = data.content;
                _this.eventsPresent(_this.eventList);
                // newly added for printing site and bpg name in pdf
                if (_this.selectedSiteId == null || _this.selectedSiteId == undefined || _this.selectedSiteId == 0) {
                    _this.siteNamePrint = _this.selectAllConstant;
                }
                else if (typeof (_this.selectedSiteId) == 'number') {
                    if (_this.siteList != null && _this.siteList != undefined) {
                        _this.siteNamePrint = _this.siteList.find(function (b) { return b.siteId === _this.selectedSiteId; }).siteName;
                    }
                }
                else {
                    _this.siteNamePrint = _this.selectAllConstant;
                }
                if (_this.selectedErgId == null || _this.selectedErgId == undefined
                    || _this.selectedErgId == 0) {
                    _this.bpgNamePrint = _this.selectAllConstant;
                }
                else if (typeof (_this.selectedErgId) == 'number') {
                    if (_this.bpgList != null && _this.bpgList != undefined) {
                        _this.bpgNamePrint = _this.bpgList.find(function (b) { return b.bpgId === _this.selectedErgId; }).bpgName;
                    }
                }
                else {
                    _this.bpgNamePrint = _this.selectAllConstant;
                }
            }
            _this.spinner.hide();
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** For datepicker date change
     * @class EventsListViewComponent
     * @method onChange
     */
    EventsCalendarComponent.prototype.onDateChange = function (event) {
        this.viewDate = event;
        this.setCalendarMonthForDate(event);
        this.selectedMonthYear = event;
        this.landingData =
            {
                "filter": {},
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "",
                "size": 1000,
                "sortDirection": "ASC",
                "sortProperty": null,
                "uid": ""
            };
        // this.spinner.show();
        // this.getAllEvents();
    };
    /** For site change from site list
     * @class EventsListViewComponent
     * @method siteChange
     * @returns Promise
     */
    EventsCalendarComponent.prototype.siteChange = function (event) {
        var _this = this;
        this.selectedErgId = null;
        this.selectedBpg = null;
        this.selectedSiteId = event.siteId;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgList = data;
            _this.bpgList.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
        });
    };
    /** For bpg change from bpg list
     * @class EventsListViewComponent
     * @method bpgChange
     * @returns Promise
     */
    EventsCalendarComponent.prototype.bpgChange = function (event) {
        this.selectedErgId = null;
        this.selectedErgId = event.bpgId;
    };
    /** For open Event view deatils component
      * @class EventsListViewComponent
      * @method viewEventDetails
      */
    EventsCalendarComponent.prototype.viewEventDetails = function (events) {
        this.selectedErgId = (this.selectedErgId) ? this.selectedErgId : null;
        this.searchKey = (this.searchKey) ? this.searchKey : '';
        sessionStorage.setItem(this.iconKeyList, "LIST");
        Object.assign(events, { 'componentName': 'eventsCalendarView' });
        Object.assign(events, { 'selectedSiteId': this.selectedSiteId });
        Object.assign(events, { 'selectedErgId': this.selectedErgId });
        if (this.selectedBpg !== null && this.selectedBpg !== undefined) {
            Object.assign(events, { 'selectedBpgName': this.selectedBpg.bpgName });
        }
        if (this.selectedSite !== undefined) {
            Object.assign(events, { 'selectedSiteName': this.selectedSite.siteName });
        }
        Object.assign(events, { 'searchKey': this.searchKey });
        sessionStorage.setItem("eventDetails", JSON.stringify(events));
        localStorage.setItem('searchedEventsCaledarItems', JSON.stringify(this.sarchedEventCalendarItems));
        this.router.navigate(['event-view-details']);
    };
    /** For button search
      * @class EventsListViewComponent
      * @method searchEvents
      */
    EventsCalendarComponent.prototype.searchEvents = function () {
        var fromDate = this.datePipe.transform(this.fromDate, ConstantValues.dateFormats.dateFormat);
        var toDate = this.datePipe.transform(this.toDate, ConstantValues.dateFormats.dateFormat);
        this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;
        this.selectedErgId = (this.selectedErgId) ? this.selectedErgId : null;
        this.searchKey = (this.searchKey) ? this.searchKey : '';
        if (this.selectedErgId === 0) {
            this.selectedErgId = null;
        }
        this.landingData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                    "bpgId": this.selectedErgId,
                    "fromDate": fromDate,
                    "toDate": toDate
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": this.searchKey,
                "size": 2000,
                "sortDirection": "ASC",
                "sortProperty": null,
                "uid": ""
            };
        this.sarchedEventCalendarItems = this.landingData;
        this.getAllEvents();
    };
    /** For adding 365 days to current day
      * @class BpgSiteHomePageComponent
      * @method addDays
      * @params Date, number
      */
    EventsCalendarComponent.prototype.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    EventsCalendarComponent.prototype.onOpenCalendar = function (container) {
        container.monthSelectHandler = function (event) {
            container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode('month');
    };
    EventsCalendarComponent.prototype.downloadEvents = function () {
        var filteredData = this.eventList.map(function (_a) {
            var siteName = _a.siteName, bpgName = _a.bpgName, eventName = _a.eventName, eventCreateDate = _a.eventCreateDate, startTime = _a.startTime, endTime = _a.endTime, description = _a.description;
            return ({ SiteName: siteName, BpgName: bpgName, EventName: eventName,
                EventDate: eventCreateDate, StartTime: startTime, EndTime: endTime, Description: description });
        });
        this.bpgEventsService.exportAsExcelFile(filteredData, "EventsReport");
    };
    EventsCalendarComponent.prototype.printEvents = function () {
        var printContents = document.getElementById("printEvents").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        this.spinner.hide();
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    EventsCalendarComponent.prototype.toggleExpand = function () {
        this.isExpanded = !this.isExpanded;
    };
    return EventsCalendarComponent;
}());
export { EventsCalendarComponent };
